var render, staticRenderFns
import script from "./FristBar.vue?vue&type=script&lang=js&"
export * from "./FristBar.vue?vue&type=script&lang=js&"
import style0 from "./FristBar.vue?vue&type=style&index=0&id=6ddd2990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports